import { Daycare } from '@/types/Daycare'
import { StaffPreparationTask } from '@/types/StaffPreparationTask'
import { TableCell, TableRow } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import Delete from '@mui/icons-material/Delete'
import { FunctionComponent, useState } from 'react'
import styles from './staffPreparationTask.module.scss'
import StaffPreparationTaskDialog from './Dialog/staffPreparationTaskDialog'

interface StaffPreparationTaskRowProps {
    staffPreparationTask: StaffPreparationTask
    daycare: Daycare
    canUpdate: boolean
    removeOneStaffPreparationTask: (staffPreparationTaskId: number) => void
    updateOneStaffPreparationTask: (staffPreparationTask: StaffPreparationTask) => void
}

const StaffPreparationTaskRow: FunctionComponent<StaffPreparationTaskRowProps> = ({
    staffPreparationTask,
    daycare,
    canUpdate,
    removeOneStaffPreparationTask,
    updateOneStaffPreparationTask
}: StaffPreparationTaskRowProps) => {
    const [staffPreparationTaskName, setStaffPreparationTaskName] = useState<string>(staffPreparationTask?.name || '')
    const [staffPreparationTaskDuration, setStaffPreparationTaskDuration] = useState<string>(
        staffPreparationTask?.duration.toString() || ''
    )

    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false)
    const [isUpdateDialogOpen, setUpdateDialogOpen] = useState<boolean>(false)

    function openEditDialog(): void {
        setStaffPreparationTaskName(staffPreparationTask.name)
        setStaffPreparationTaskDuration(staffPreparationTask.duration.toString())
        setUpdateDialogOpen(true)
    }

    return (
        <>
            <TableRow>
                <TableCell>{staffPreparationTaskName}</TableCell>
                <TableCell>{staffPreparationTaskDuration}</TableCell>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={openEditDialog} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeleteDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <StaffPreparationTaskDialog
                open={isUpdateDialogOpen}
                mode='edit'
                handleClose={() => setUpdateDialogOpen(false)}
                daycare={daycare}
                staffPreparationTaskId={staffPreparationTask.id}
                staffPreparationTaskName={staffPreparationTaskName}
                setStaffPreparationTaskName={setStaffPreparationTaskName}
                staffPreparationTaskDuration={staffPreparationTaskDuration}
                setStaffPreparationTaskDuration={setStaffPreparationTaskDuration}
                updateOneStaffPreparationTask={updateOneStaffPreparationTask}
            />
            <StaffPreparationTaskDialog
                open={isDeleteDialogOpen}
                mode='delete'
                handleClose={() => setDeleteDialogOpen(false)}
                daycare={daycare}
                staffPreparationTaskId={staffPreparationTask.id}
                removeOneStaffPreparationTask={removeOneStaffPreparationTask}
            />
        </>
    )
}

export default StaffPreparationTaskRow
